export default __webpack_public_path__ + "static/media/search.9284ab03.gif";